import * as React from 'react';
export var ArrowUpCircle = function ArrowUpCircle(_a) {
  var className = _a.className;
  return React.createElement("svg", {
    className: className,
    width: "16",
    height: "16",
    viewBox: "0 0 48 48"
  }, React.createElement("g", {
    transform: "translate(-1247 -816)"
  }, React.createElement("g", {
    transform: "translate(1460 -22) rotate(-90)"
  }, React.createElement("path", {
    d: "M-855.4-191.1l-9.8-9.8l3-3l14.9,14.9l-14.8,14.8l-3-3l9.8-9.8h-21.3v-4.2H-855.4z"
  }), React.createElement("path", {
    d: "M-886-189c0,13.3,10.7,24,24,24s24-10.7,24-24s-10.7-24-24-24S-886-202.3-886-189z M-881.8-189\n        c0-10.9,8.9-19.8,19.8-19.8c10.9,0,19.8,8.9,19.8,19.8c0,10.9-8.9,19.8-19.8,19.8C-872.9-169.2-881.8-178.1-881.8-189z"
  }))));
};